import React, { useState } from "react"
import { useDispatch } from "react-redux"
import Button from "react-bootstrap/Button"
import InputGroup from "react-bootstrap/InputGroup"
import { Title, Text, DurationInput } from "components/Form"
import { reports, message } from "state_management"
import * as XLSX from "xlsx"
import useT from "utils/hooks/useT"

import "./index.scss"
import { DateTime } from "luxon"

// Makes the client download an excel file with data
export default function ReportConfig({ onClose, id }) {
  const [analysisTaskCheck, setAnalysisTaskCheck] = useState(false)
  const [fromDate, setFromDate] = useState(null)
  const [fromTime, setFromTime] = useState(null)
  const [toDate, setToDate] = useState(null)
  const [toTime, setToTime] = useState(null)

  const dispatch = useDispatch()
  const { t } = useT("common")
  const { t: tm } = useT("messages")

  function validateSubmit() {
    if (!fromDate || !fromTime || !toDate || !toTime) {
      return tm("pleaseFillAllPeriodFields")
    }
    if (!analysisTaskCheck) {
      return tm("pleaseSelectReportType")
    }
    return false
  }

  function createExcelData(columns, rows, fileName) {
    let sortedColumns = columns.sort((a, b) => {
      return b.columnIndex > a.columnIndex ? -1 : b.columnIndex < a.columnIndex ? 1 : 0
    })
    let newRows = []
    rows.forEach((row) => {
      const newRow = {}
      if (row.finishTime) {
        newRow["finishTime"] = modifyDateStr(row.finishTime)
      }
      if (row.startTime) {
        newRow["startTime"] = modifyDateStr(row.startTime)
      }
      newRows.push({ ...row, ...newRow })
    })
    return { dataset: newRows, columns: sortedColumns, fileName: fileName }
  }

  function modifyDateStr(str) {
    let a = DateTime.fromISO(str)
    return (
      a.year.toString() +
      "-" +
      a.month.toString() +
      "-" +
      a.day.toString() +
      " " +
      a.hour.toString() +
      ":" +
      a.minute.toString()
    )
  }

  function handleExportExcel(report) {
    // Extract headers from columns
    const headers = report.columns.map((column) => column.name)
    // Extract data using keys from columns, ensuring order
    const data = report.dataset.map((row) => report.columns.map((column) => row[column.key]))
    // Create an array of arrays with headers and data
    const dataWithHeaders = [headers, ...data]
    // Create a new worksheet
    const ws = XLSX.utils.aoa_to_sheet(dataWithHeaders)

    // Create a new workbook
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, report.fileName)

    // Export the workbook
    XLSX.writeFile(wb, `${report.fileName}.xlsx`)
  }

  function submitFunction() {
    const msg = validateSubmit()
    if (msg) {
      dispatch(message.warning(msg))
      return
    }
    dispatch(reports.analysisTasks(fromDate.plus(fromTime), toDate.plus(toTime), id)).then((res) => {
      const propertyObj = createExcelData(res.columns, res.rows, res.filename)
      if (!propertyObj.columns.length) {
        dispatch(message.warning(tm("reportEmptyInInterval", { fileName: propertyObj.fileName })))
        return
      }
      // Directly handle Excel export
      handleExportExcel(propertyObj)
    })
  }

  return (
    <div className="ReportConfig-container">
      <h3>{t("reportGenerator")}</h3>
      <div className="ReportConfig-From">
        <InputGroup>
          <InputGroup.Text>{t("from")}</InputGroup.Text>
          <Text
            type="date"
            value={fromDate ? fromDate.toFormat("yyyy-MM-dd") : ""}
            onChange={(value) => {
              if (!value) {
                setFromDate(undefined)
                return
              }
              try {
                const newDate = DateTime.fromFormat(value, "yyyy-MM-dd")
                setFromDate(newDate)
              } catch (error) {
                // Handle invalid date format
              }
            }}
          />
          <DurationInput value={fromTime} onChange={setFromTime} isTime />
        </InputGroup>
      </div>
      <div className="ReportConfig-To">
        <InputGroup.Text>{t("to")}</InputGroup.Text>
        <Text
          type="date"
          value={toDate ? toDate.toFormat("yyyy-MM-dd") : ""}
          onChange={(value) => {
            if (!value) {
              setToDate(undefined)
              return
            }
            try {
              const newDate = DateTime.fromFormat(value, "yyyy-MM-dd")
              setToDate(newDate)
            } catch (error) {
              // Handle invalid date format
            }
          }}
        />
        <DurationInput value={toTime} onChange={setToTime} isTime />
      </div>
      <div className={`ReportConfig-CheckBox`}>
        <InputGroup>
          <Title>{t("analysisTaskTimePerformerSamples")}</Title>
          <input
            type="checkbox"
            defaultChecked={analysisTaskCheck}
            onClick={() => setAnalysisTaskCheck(!analysisTaskCheck)}
          />
        </InputGroup>

        {/* {showDownload &&
          excelProperties.map((obj) => (
            <div className="ReportConfig-DownloadBtns" key={obj.fileName}>
              <Button onClick={() => handleExportExcel(obj)}>Download {obj.fileName}</Button>
            </div>
          ))} */}
      </div>
      <div className="ReportConfig-buttons">
        <Button variant="secondary" onClick={onClose}>
          {t("cancel")}
        </Button>
        <Button variant="primary" onClick={submitFunction}>
          {t("generate")}
        </Button>
      </div>
    </div>
  )
}
